import React, { useState } from 'react';
import SideNavUx from "../../layout/sidenav";
import NavBarUx from "../../layout/navbar";
import FooterUx from "../layout/footer_ux";
import {Button} from "@material-tailwind/react";

const PaymentSearchUx = (props) => {
    const [openSidenav, setOpenSidenav] = useState(false);
    const [formData, setFormData] = useState({
        discountCode: "",
        nameOnCard: "",
        cardNumber: "",
        expirationMonth: "01",
        expirationYear: "2024",
        securityCode: "",
    });

    const routes = {main: 'Inicio', current: 'Pagos'}


    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("Form Data:", formData);
        alert("Form submitted successfully!");
    };

    return (
        <>
            <SideNavUx setOpenSidenav={setOpenSidenav} openSidenav={openSidenav}/>
            <div className="p-4 xl:ml-80">
                <NavBarUx routes={routes} setOpenSidenav={setOpenSidenav} openSidenav={openSidenav}/>
                <div className="min-w-screen min-h-screen py-5">
                    <div className="w-full bg-white  border-gray-200 px-5 py-10 text-gray-800">
                        <div className="w-full">
                            <div className="-mx-3 md:flex">
                                <div className="px-3 md:w-8/12 lg:pr-10">
                                    <div className="w-full mx-auto text-gray-800 font-light mb-6 border-b border-gray-200 pb-6">
                                        <div className="w-full flex items-center">
                                            <div className="flex-grow pl-3">
                                                <h6 className="font-semibold uppercase text-gray-600">Busqueda de predio</h6>
                                            </div>
                                        </div>
                                    </div>
                                    {/* Discount Code */}
                                    <div className="mb-6 pb-6 border-b border-gray-200">
                                        <div className="-mx-2 flex items-end justify-start">
                                            <div className="flex-grow px-2 lg:max-w-xs">
                                                <label className="text-gray-600 font-semibold text-sm mb-2 ml-1">
                                                    Clave predio
                                                </label>
                                                <div>
                                                    <input
                                                        className="w-full px-3 py-2 border border-gray-200 rounded-md focus:outline-none focus:border-indigo-500 transition-colors"
                                                        placeholder="51XXXX-XXX-XXX"
                                                        type="text"
                                                    />
                                                </div>
                                            </div>
                                            <div className="items-center h-full px-2">
                                                <Button className="w-full max-w-xs mx-auto border border-transparent bg-gray-500 hover:bg-blue-gray-50 text-white rounded-md px-5 py-2 font-semibold" fullWidth onClick={handleSubmit}>
                                                    BUSCAR
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <FooterUx/>
            </div>
        </>
    );
}

export default PaymentSearchUx;